import { injectable } from 'inversify';

import { CurrencyListDataService } from 'src/app/general/currencies/list/currency-list.data';
import { ConfigOptionDataService } from '../general/config-option/form/config-option-form.data';

@injectable()
export class InitializeService {
	private currencyDataService: CurrencyListDataService;
	private configOptionService: ConfigOptionDataService;

	constructor() {
	}

	async init(): Promise<void> {
		const promises: Promise<any>[] = [];

		this.currencyDataService = CurrencyListDataService.make();
		this.currencyDataService.addSorting('id', 'asc', true);
		this.currencyDataService.addFilter('isDeleted', 'eq', false);

		promises.push(this.currencyDataService.load(query => query));

		this.configOptionService = ConfigOptionDataService.make();
		this.configOptionService.addSorting("key", "asc");
		this.configOptionService.pageSize = 100;
		promises.push(this.configOptionService.load(query => query));

		await Promise.all(promises);
	}
	
	currencies = (): CurrencySummary[] => {
		return !!this.currencyDataService? this.currencyDataService.items.slice(): [];
	}
	
	configOptions = (): ConfigOptionItem[] => {
		return !!this.currencyDataService ? this.configOptionService.items.slice(): [];
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/initialize.service.ts